var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconTime = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ico-time",
    width: 20.946,
    height: 24,
    viewBox: "0 0 20.946 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ico-time .a{fill:#e4eaf2;}.ico-time .b{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20.946,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.4,5.686l.566-.566.309.309a.436.436,0,1,0,.617-.617l-.616-.617h0l-.617-.617a.436.436,0,1,0-.617.617l.309.309-.628.628a10.414,10.414,0,0,0-5.816-2.065V2.182H12A1.091,1.091,0,1,0,12,0H8.945a1.091,1.091,0,0,0,0,2.182h1.091v.884a10.423,10.423,0,0,0-6.3,2.452L2.719,4.5l.309-.309a.436.436,0,0,0-.617-.617l-.617.617h0l-.617.617a.436.436,0,1,0,.617.617L2.1,5.12l.988.988A10.474,10.474,0,1,0,17.4,5.686m-8.677-4.6A.218.218,0,0,1,8.945.873H12a.218.218,0,0,1,0,.436H10.484l-.012,0-.012,0H8.945a.218.218,0,0,1-.218-.218m1.746,22.036a9.6,9.6,0,1,1,9.6-9.6,9.611,9.611,0,0,1-9.6,9.6",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M206.126,303.819a7.21,7.21,0,0,1-1.166.643.436.436,0,1,0,.35.8,8.134,8.134,0,0,0,1.307-.721.436.436,0,1,0-.49-.722",
    transform: "translate(-191.598 -284.304)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M45.113,84.738a8.1,8.1,0,1,0,0,16.208.436.436,0,0,0,0-.873,7.231,7.231,0,1,1,7.231-7.232,7.159,7.159,0,0,1-1.521,4.437.436.436,0,0,0,.689.536,8.026,8.026,0,0,0,1.7-4.972,8.113,8.113,0,0,0-8.1-8.1",
    transform: "translate(-34.64 -79.315)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M104,184.091a1.529,1.529,0,0,0-1.527,1.527,1.507,1.507,0,0,0,.176.7l-2.349,2.118a.436.436,0,0,0,.584.648l2.37-2.137a1.51,1.51,0,0,0,.746.2,1.527,1.527,0,1,0,0-3.054m0,2.182a.655.655,0,1,1,.654-.654.655.655,0,0,1-.654.654",
    transform: "translate(-93.745 -172.309)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTime, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_time.6ac01335.svg";
export { ForwardRef as ReactComponent };